import React from "react";
import ProjectsLayout from "../layouts/ProjectsLayout";

const Projects = () => {
  return (
    <div className="p-8 bg-gray-100">
      <ProjectsLayout />
    </div>
  );
};

export default Projects;
